import EditProfileContainer from './EditProfileContainer';
import EditProfileStore from "./EditProfileStore";

export default EditProfileStore(EditProfileContainer);